/**
 * @class
 * @description This class stores information about a Rendition
 * @exports Rendition
 */
export default class Rendition {
    constructor() {
        this.uri = '';
        this.bandwidth = 0;
        this.isAudio = false;
        this.bandwidthPosition = -1;
        this.targetDuration = 0;
        this.segments = new Map();
        this.isMaxRendition = false;
    }
}
